module.exports = __webpack_public_path__ + "img/start-hero.94ad3258.jpg";